
import { Component, Prop, Vue } from 'vue-property-decorator'

const statusOptions = {
    Treated: {
        key: 1,
        label: '已处理'
    },
    unTreated: {
        key: 0,
        label: '未处理'
    }
}

@Component({
    name: 'feedback_table',
    components: {}
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]
    @Prop({ required: true }) private curType!: string
    private statusOptions = statusOptions

    get isInclude() {
        return this.curType === 'include'
    }

    onGoDetail(row: any) {
        const id = row.id
        this.$router.push({
            name: 'feedback-detail',
            params: {
                id,
                type: this.curType
            }
        })
    }

    onStatusChange(row: any) {
        this.$emit('update', row)
    }
}
